import React from "react";
import emailjs from "emailjs-com";
import { useState } from "react";
import "./Contacts.css";
import { Helmet } from "react-helmet-async";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const ContactPage = () => {
  const currentYear = new Date().getFullYear();
  const years = Array.from({ length: 20 }, (_, i) => currentYear - i);

  const [loading, setLoading] = useState(false);

  const [errors, setErrors] = useState({
    email: "",
    phone: "",
  });

  const sendEmail = (e) => {
    e.preventDefault();
    setLoading(true);

    const form = e.target;

    const email = form.email.value.trim();

    const phone = form.phone.value.trim();

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const phoneRegex = /^[6-9]\d{9}$/;

    const newErrors = {};

    if (!emailRegex.test(email)) {
      newErrors.email = "Enter a valid email address";
    }

    if (!phoneRegex.test(phone)) {
      newErrors.phone = "Enter a valid 10 digit mobile number";
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      setLoading(false);
      return;
    }

    setErrors({});

    emailjs
      .sendForm(
        process.env.REACT_APP_EMAILJS_SERVICE_ID,
        process.env.REACT_APP_EMAILJS_CONTACT_TEMPLATE_ID,
        form,
        process.env.REACT_APP_EMAILJS_PUBLIC_KEY
      )
      .then(
        () => {
          toast.success("Message sent successfully! We will contact you soon.");
          e.target.reset();
          setLoading(false);
        },
        () => {
          toast.error("Something went wrong. Please try again.");
          setLoading(false);
        }
      );


  };

  return (
    <>
      <Helmet>
        <title>Contact KitKat Tech – Get Support and Assistance</title>
        <meta
          name="description"
          content="Get in touch with KitKat Tech for reliable IT support, website development, software solutions, mobile apps, and digital marketing services to grow your business."
        />

        <meta
          name="keywords"
          content="Digital marketing, Mobile apps, App development, Web services, Website development, IT support, Software solutions, Tech support"
        />


        {/* <!-- Canonical URL --> */}
        <link rel="canonical" href="https://kitkatsoftwaretechnologies.com/contact-us" />

        {/* <!-- Hreflang Tags --> */}
        <link rel="alternate" hrefLang="en-US" href="https://kitkatsoftwaretechnologies.com/contact-us" />
        <link rel="alternate" hrefLang="en-GB" href="https://kitkatsoftwaretechnologies.com/contact-us" />
        <link rel="alternate" hrefLang="en-MY" href="https://kitkatsoftwaretechnologies.com/contact-us" />
        <link rel="alternate" hrefLang="en-SG" href="https://kitkatsoftwaretechnologies.com/contact-us" />
        <link rel="alternate" hrefLang="en-AE" href="https://kitkatsoftwaretechnologies.com/contact-us" />
        <link rel="alternate" hrefLang="x-default" href="https://kitkatsoftwaretechnologies.com/contact-us" />

      </Helmet>
      <div className="fullcontrol">
        {/* Google Map */}
        <div className="contact-page-map-container">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3916.322585449735!2d76.9765124641843!3d11.01440580776919!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ba859b2d555eeff%3A0xbcb671713da40ffb!2sSri+Krishna+Complex%2C+72%2C+Kattoor+Rd%2C+P+N+Palayam%2C+Coimbatore%2C+Tamil+Nadu+641037!5e0!3m2!1sen!2sin!4v1510310937877"
            width="100%"
            height="300"
            style={{ border: "0" }}
            allowFullScreen
            title="map"
          ></iframe>
        </div>

        {/* Contact Info */}
        <div className="contact-page-container">
          <div className="contact-page-info">
            <h2 className="contact-page-title">Get in Touch With Kitkat Software Technologies</h2>
            <ul className="contact-page-list">
              <li>
                <i className="fa-solid fa-location-dot"></i>
                No.70/77, 1st floor, Krishna Complex, Kattor Road,
                Papanaickenpalayam, Coimbatore-641037
              </li>
              <li>
                <i id="phone2" className="fa-solid fa-phone"></i> Phone: 0422
                495 7272
              </li>
              <li>
                <i id="phone1" className="fa-solid fa-mobile"></i> Mobile:
                +917010816299
              </li>

            </ul>
          </div>
        </div>

        {/* Registration Form */}
        <div className="contact-page-form-container">
          <div className="contact-page-form">
            <h2 className="contact-page-form-title">
              Register for More Information
            </h2>

            <form onSubmit={sendEmail} >
              <div className="contact-page-form-group">
                <label htmlFor="name" className="contact-page-label">
                  Name
                </label>
                <input
                  type="text"
                  name="name"
                  placeholder="Enter your name"
                  maxLength="20"
                  required
                  className="contact-page-input"
                />
              </div>



              <div className="contact-page-form-group">
                <label htmlFor="email" className="contact-page-label">
                  Email
                </label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  placeholder="Enter your email"
                  required
                  className="contact-page-input"
                />
                {errors.email && <span className="form-error">{errors.email}</span>}
              </div>

              <div className="contact-page-form-group">
                <label htmlFor="phone" className="contact-page-label">
                  Mobile Number
                </label>
                <input
                  type="tel"
                  id="phone"
                  name="phone"
                  placeholder="Enter your mobile number"
                  maxLength="10"
                  required
                  className="contact-page-input"
                  onInput={(e) => {
                    e.target.value = e.target.value.replace(/[^0-9]/g, "");
                  }}
                />
                {errors.phone && <span className="form-error">{errors.phone}</span>}
              </div>

              <div className="contact-page-form-group">
                <label htmlFor="message" className="contact-page-label">
                  Message
                </label>
                <textarea
                  type="text"
                  id="message"
                  name="message"
                  placeholder="Type your message here"
                  required
                  className="contact-page-input"
                />
              </div>



              <div className="contact-page-form-group">
                <button type="submit" className="contact-page-submit-button" disabled={loading}>
                  {loading ? "Sending..." : "Send Message"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      {/* Toast Notification */}
      <ToastContainer
        position="top-right"
        autoClose={4000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        pauseOnHover
        theme="colored"
      />
    </>
  );
};

export default ContactPage;
